const KeyUserRoutes = [{
  path: "keyuser",
  name: "KeyUser",
  redirect: {
    name: "KeyUser List"
  },
  component: () =>
    import( /* webpackChunkName: "KeyUser" */ "../../views/keyUser/KeyUser.vue"),
  children: [{
      path: "list",
      name: "KeyUser List",
      component: () =>
        import( /* webpackChunkName: "KeyUser" */ "../../views/keyUser/KeyUserList.vue")
    },
    {
      path: "add",
      name: "KeyUser Add",
      component: () =>
        import( /* webpackChunkName: "KeyUser" */ "../../views/keyUser/CrudKeyUsers.vue")
    },
    {
      path: "edit/:id",
      name: "KeyUser Edit",
      component: () =>
        import( /* webpackChunkName: "KeyUser" */ "../../views/keyUser/CrudKeyUsers.vue")
    },
    {
      path: "details/:id",
      name: "KeyUser Details",
      component: () =>
        import( /* webpackChunkName: "KeyUser" */ "../../views/keyUser/CrudKeyUsers.vue")
    }
  ]
}];

export default KeyUserRoutes;
